import { DateRange } from '../date/DateRange'

export interface FilterField {
  fieldId: string
  displayText: string
}
export interface TableFilter {
  column: FilterField
  operator: FilterField
  value: FilterField | string | Date | DateRange | Array<string>
}

export const isTableFilterType = (request: any): request is Array<TableFilter> => {
  if (!Array.isArray(request)) {
    return false
  }
  if (request.length === 0) {
    return true
  }
  return 'column' in request[0] && 'operator' in request[0]
}
